export type SiteRole = 'system' | 'admin' | 'moderator' | 'premium' | 'player' | 'disabled' | 'inactive'

export const SITE_ROLE_COLORS: Record<SiteRole, string> = {
  system: '#19c519',
  admin: '#ff0000',
  moderator: '#bd00ff',
  premium: '#eab308',
  player: '#489cd6',
  disabled: '#777f89',
  inactive: '#777f89',
}

export const SITE_ROLE_ORDER: Record<SiteRole, number> = {
  system: 0,
  admin: 1,
  moderator: 2,
  premium: 3,
  player: 4,
  disabled: 5,
  inactive: 6,
}

export function normalizeSiteRole(value: unknown): SiteRole {
  const role = String(value || '').trim().toLowerCase() as SiteRole
  return Object.prototype.hasOwnProperty.call(SITE_ROLE_COLORS, role) ? role : 'player'
}

export function roleColor(value: unknown): string {
  return SITE_ROLE_COLORS[normalizeSiteRole(value)]
}

export function roleOrder(value: unknown): number {
  return SITE_ROLE_ORDER[normalizeSiteRole(value)]
}

export function roleNickStyle(value: unknown): Record<string, string> {
  const role = normalizeSiteRole(value)
  if (role === 'system') {
    return {
      color: SITE_ROLE_COLORS.system,
      textShadow: 'none',
      WebkitTextStroke: '0.1px currentcolor',
    }
  }
  return {
    color: SITE_ROLE_COLORS[role],
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.85)',
  }
}
